import React from 'react';
import { ArrowUpIcon } from 'lucide-react';
export const NotifyReadersViz = () => <div className="h-64" data-id="element-5537" data-mp="12twi1xszw7x8">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5538" data-mp="12td8p5heurut">
      Notification Performance
    </h4>
    <div className="relative h-48" data-id="element-5539" data-mp="xtqpmfewihe3">
      <div className="absolute inset-0 flex flex-col" data-id="element-5540" data-mp="xusa1aht4g8h">
        <div className="bg-teal-500 text-white p-3 rounded-t-lg flex justify-between items-center" data-id="element-5541" data-mp="sw8ohb74l6gn">
          <span data-id="element-5542" data-mp="1qjh3cncmfh9o">Readers who finished Book 1</span>
          <span className="font-bold" data-id="element-5543" data-mp="1qla8fy7l5tfk">1,245</span>
        </div>
        <div className="bg-teal-400 text-white p-3 flex justify-between items-center" data-id="element-5544" data-mp="1llfjw1ba9fxo">
          <span data-id="element-5545" data-mp="1gscnzmj19ueb">Notifications sent</span>
          <span className="font-bold" data-id="element-5546" data-mp="1grbcxi20p7wl">1,245</span>
        </div>
        <div className="bg-teal-300 text-teal-900 p-3 flex justify-between items-center" data-id="element-5547" data-mp="1bt9w73s2dkoa">
          <span data-id="element-5548" data-mp="299yvoqtjkaui">Notifications opened</span>
          <span className="font-bold" data-id="element-5549" data-mp="29bs0e0klgkzv">932 (74.9%)</span>
        </div>
        <div className="bg-teal-200 text-teal-900 p-3 flex justify-between items-center" data-id="element-5550" data-mp="24i70g2zfxgy1">
          <span data-id="element-5551" data-mp="3eq9s4s7mi74i">Clicked to view new book</span>
          <span className="font-bold" data-id="element-5552" data-mp="3erkuqopc18u1">687 (55.2%)</span>
        </div>
        <div className="bg-teal-100 text-teal-900 p-3 rounded-b-lg flex justify-between items-center" data-id="element-5553" data-mp="3jns30o57awf5">
          <span data-id="element-5554" data-mp="34yvuyr359jej">Purchased new book</span>
          <span className="font-bold" data-id="element-5555" data-mp="39yi6mw3bqrl8">243 (19.5%)</span>
        </div>
      </div>
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5556" data-mp="39w5lyb66m34h">
      Based on "The Silent Echo" sequel release
    </div>
  </div>;
export const ABTestingViz = () => <div className="h-64" data-id="element-5557" data-mp="301vowg6aognf">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5558" data-mp="2zxzi3o0temwz">
      Cover A/B Test Results
    </h4>
    <div className="grid grid-cols-2 gap-6 h-48" data-id="element-5559" data-mp="2m2w1tcyfk9td">
      <div className="border rounded-lg p-3" data-id="element-5560" data-mp="2r0p783rwszsl">
        <div className="flex items-center mb-2" data-id="element-5561" data-mp="2r1h37fpf4zje">
          <div className="w-12 h-16 bg-indigo-100 rounded mr-3 flex items-center justify-center text-xs" data-id="element-5562" data-mp="ka7vguqhp69d">
            Cover A
          </div>
          <div data-id="element-5563" data-mp="p66o4uiupafl">
            <div className="text-sm font-medium" data-id="element-5564" data-mp="nr3z3zk9171n">Original Cover</div>
            <div className="text-xs text-gray-500" data-id="element-5565" data-mp="nsf2hy9s8cs8">
              Dark theme with minimal text
            </div>
          </div>
        </div>
        <div className="space-y-2" data-id="element-5566" data-mp="dso61r1nvnpi">
          <div className="flex justify-between text-sm" data-id="element-5567" data-mp="dtpinzybsi9c">
            <span data-id="element-5568" data-mp="8u35trmet412">Impressions:</span>
            <span className="font-medium" data-id="element-5569" data-mp="8uwe4x10o1lb">5,432</span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-5570" data-mp="16hbvlytg0z8v">
            <span data-id="element-5571" data-mp="16gtw8tbhi4wq">Click rate:</span>
            <span className="font-medium" data-id="element-5572" data-mp="11isc052bnzjo">8.2%</span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-5573" data-mp="11klhvi542fqm">
            <span data-id="element-5574" data-mp="wqqqrtn6eyhi">Downloads:</span>
            <span className="font-medium" data-id="element-5575" data-mp="wpz3d63qg72b">214</span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-5576" data-mp="rrnyzaw7iorh">
            <span data-id="element-5577" data-mp="1p8346y5lwlm7">Completion rate:</span>
            <span className="font-medium" data-id="element-5578" data-mp="1p94olt8iikgl">62%</span>
          </div>
        </div>
      </div>
      <div className="border rounded-lg p-3 bg-indigo-50" data-id="element-5579" data-mp="1kgbmze8cbs8q">
        <div className="flex items-center mb-2" data-id="element-5580" data-mp="1sq0kgbw15gyb">
          <div className="w-12 h-16 bg-indigo-200 rounded mr-3 flex items-center justify-center text-xs" data-id="element-5581" data-mp="1srbz56r0k947">
            Cover B
          </div>
          <div data-id="element-5582" data-mp="1wtfc5ztbzlrl">
            <div className="text-sm font-medium" data-id="element-5583" data-mp="21qyqt0txy0k2">New Cover Design</div>
            <div className="text-xs text-gray-500" data-id="element-5584" data-mp="21ss0yq3rj2wt">
              Character-focused with vibrant colors
            </div>
          </div>
        </div>
        <div className="space-y-2" data-id="element-5585" data-mp="2bpo9gvtnvp1d">
          <div className="flex justify-between text-sm" data-id="element-5586" data-mp="2bomnhwb3xi4v">
            <span data-id="element-5587" data-mp="2fpoooiol449h">Impressions:</span>
            <span className="font-medium" data-id="element-5588" data-mp="2fonc29rx79pn">5,489</span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-5589" data-mp="2ki813cbjctcp">
            <span data-id="element-5590" data-mp="2pg9vgteewf3h">Click rate:</span>
            <span className="font-medium text-green-600" data-id="element-5591" data-mp="2pgjbpp9nn7vz">12.7% (+55%)</span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-5592" data-mp="2ufw5yv2uvh8l">
            <span data-id="element-5593" data-mp="2ud9sketaa7ig">Downloads:</span>
            <span className="font-medium text-green-600" data-id="element-5594" data-mp="2zdxsjpzhpyot">342 (+60%)</span>
          </div>
          <div className="flex justify-between text-sm" data-id="element-5595" data-mp="6qdnr1d9oa">
            <span data-id="element-5596" data-mp="3w3zw2y3163ht">Completion rate:</span>
            <span className="font-medium text-green-600" data-id="element-5597" data-mp="3r710eb3pxohi">68% (+10%)</span>
          </div>
        </div>
      </div>
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5598" data-mp="9qj9rcn46wsu">
      Test period: Last 30 days
    </div>
  </div>;
export const GenreBenchmarkingViz = () => <div className="h-64" data-id="element-5599" data-mp="4tj1cv2slhyk">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5600" data-mp="3d6ghzg1ptuoj">
      Mystery/Thriller Genre Benchmarks
    </h4>
    <div className="h-48 flex flex-col justify-between" data-id="element-5601" data-mp="388osstsggmo1">
      <div className="flex items-center" data-id="element-5602" data-mp="38a88oja78vpa">
        <div className="w-32 text-sm" data-id="element-5603" data-mp="3m7wt5q0cu0tt">Download Rate</div>
        <div className="flex-1 h-8 bg-gray-100 rounded-full overflow-hidden" data-id="element-5604" data-mp="3m5bq4xobleuh">
          <div className="h-full bg-indigo-200 rounded-full" style={{
          width: '65%'
        }} data-id="element-5605" data-mp="3i4rrfpo3m368">
            <div className="h-full bg-indigo-500 rounded-full flex items-center px-3" style={{
            width: '85%'
          }} data-id="element-5606" data-mp="xgdjvmg1u79e">
              <span className="text-xs text-white" data-id="element-5607" data-mp="19y6flh729jrc">Your book: 85%</span>
            </div>
          </div>
          <div className="mt-1 text-xs text-gray-500" data-id="element-5608" data-mp="v1fen3hqnzzm">Genre average: 65%</div>
        </div>
      </div>
      <div className="flex items-center" data-id="element-5609" data-mp="1000hzbsaezsa">
        <div className="w-32 text-sm" data-id="element-5610" data-mp="100saueui2jev">Completion Rate</div>
        <div className="flex-1 h-8 bg-gray-100 rounded-full overflow-hidden" data-id="element-5611" data-mp="1npb87zc0hbs6">
          <div className="h-full bg-indigo-200 rounded-full" style={{
          width: '58%'
        }} data-id="element-5612" data-mp="1soxwd3tdocfr">
            <div className="h-full bg-indigo-500 rounded-full flex items-center px-3" style={{
            width: '78%'
          }} data-id="element-5613" data-mp="1dz9tvz9gn7qg">
              <span className="text-xs text-white" data-id="element-5614" data-mp="26ogv560aubfe">Your book: 78%</span>
            </div>
          </div>
          <div className="mt-1 text-xs text-gray-500" data-id="element-5615" data-mp="2bggxf53udgf5">Genre average: 58%</div>
        </div>
      </div>
      <div className="flex items-center" data-id="element-5616" data-mp="2lacs6j2mkl9g">
        <div className="w-32 text-sm" data-id="element-5617" data-mp="2l91oskd3dfiv">Avg. Read Time</div>
        <div className="flex-1 h-8 bg-gray-100 rounded-full overflow-hidden" data-id="element-5618" data-mp="2gdmcvxyn9tp3">
          <div className="h-full bg-indigo-200 rounded-full" style={{
          width: '70%'
        }} data-id="element-5619" data-mp="2c9y4jd26uu2s">
            <div className="h-full bg-indigo-500 rounded-full flex items-center px-3" style={{
            width: '62%'
          }} data-id="element-5620" data-mp="27dqwneq8f8i7">
              <span className="text-xs text-white" data-id="element-5621" data-mp="1xka56hdki5hp">Your book: 62%</span>
            </div>
          </div>
          <div className="mt-1 text-xs text-gray-500" data-id="element-5622" data-mp="1sn0587sjybfm">Genre average: 70%</div>
        </div>
      </div>
      <div className="flex items-center" data-id="element-5623" data-mp="1omzp8ipt1s6g">
        <div className="w-32 text-sm" data-id="element-5624" data-mp="1jlsgagbxemy7">Reread Rate</div>
        <div className="flex-1 h-8 bg-gray-100 rounded-full overflow-hidden" data-id="element-5625" data-mp="1jlacmymxp6g9">
          <div className="h-full bg-indigo-200 rounded-full" style={{
          width: '25%'
        }} data-id="element-5626" data-mp="1eoa5ekeclxnk">
            <div className="h-full bg-indigo-500 rounded-full flex items-center px-3" style={{
            width: '32%'
          }} data-id="element-5627" data-mp="3v9f7ii85etrd">
              <span className="text-xs text-white" data-id="element-5628" data-mp="419s5qmdgz4x">Your book: 32%</span>
            </div>
          </div>
          <div className="mt-1 text-xs text-gray-500" data-id="element-5629" data-mp="82d6g8orun41">Genre average: 25%</div>
        </div>
      </div>
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5630" data-mp="3cixl0vdwsueg">
      Data from 1,245 mystery/thriller titles published in the last 2 years
    </div>
  </div>;
export const SeriesPerformanceViz = () => <div className="h-64" data-id="element-5631" data-mp="3lazg0e57lihc">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5632" data-mp="3lbhj9uqagwyr">
      Echo Series Reader Flow
    </h4>
    <div className="h-48 flex items-end space-x-1" data-id="element-5633" data-mp="2ou4trc88faq6">
      <div className="flex flex-col items-center" data-id="element-5634" data-mp="2orinrh0zp3a2">
        <div className="h-40 w-24 bg-indigo-500 rounded-t-lg flex flex-col justify-end" data-id="element-5635" data-mp="2stvi79aaderj">
          <div className="bg-white mx-2 mb-2 p-1 rounded text-xs text-center" data-id="element-5636" data-mp="1m6t4yvuuin7j">
            <div className="font-medium" data-id="element-5637" data-mp="1h8rli9ticlvj">Book 1</div>
            <div data-id="element-5638" data-mp="1hacfnybwu2sv">2,458 readers</div>
            <div data-id="element-5639" data-mp="1w5seshrckow4">100%</div>
          </div>
        </div>
        <div className="text-xs mt-1" data-id="element-5640" data-mp="1w7d9q8hkq9ui">The Silent Echo</div>
      </div>
      <div className="flex items-center text-gray-400 -mx-1" data-id="element-5641" data-mp="1r6fr5usnjdsh">→</div>
      <div className="flex flex-col items-center" data-id="element-5642" data-mp="256gtleoketa2">
        <div className="h-32 w-24 bg-indigo-400 rounded-t-lg flex flex-col justify-end" data-id="element-5643" data-mp="2555nh87nd9fs">
          <div className="bg-white mx-2 mb-2 p-1 rounded text-xs text-center" data-id="element-5644" data-mp="206cdhprkk0kd">
            <div className="font-medium" data-id="element-5645" data-mp="2ewte56wdqmg7">Book 2</div>
            <div data-id="element-5646" data-mp="2eycraomqohdr">1,842 readers</div>
            <div data-id="element-5647" data-mp="29xglu6mqon68">74.9%</div>
          </div>
        </div>
        <div className="text-xs mt-1" data-id="element-5648" data-mp="29xys7w348hrv">Echoes of Darkness</div>
      </div>
      <div className="flex items-center text-gray-400 -mx-1" data-id="element-5649" data-mp="2nxrhdmyzupxq">→</div>
      <div className="flex flex-col items-center" data-id="element-5650" data-mp="2jvmmkkwt7n9i">
        <div className="h-24 w-24 bg-indigo-300 rounded-t-lg flex flex-col justify-end" data-id="element-5651" data-mp="2jx7lsnu2judp">
          <div className="bg-white mx-2 mb-2 p-1 rounded text-xs text-center" data-id="element-5652" data-mp="32k6ojukqajv9">
            <div className="font-medium" data-id="element-5653" data-mp="37hp0ltu1lf7h">Book 3</div>
            <div data-id="element-5654" data-mp="37gdsjhtkdlak">1,473 readers</div>
            <div data-id="element-5655" data-mp="2tjry6gswqekw">59.9%</div>
          </div>
        </div>
        <div className="text-xs mt-1" data-id="element-5656" data-mp="2tlbgecy4izpb">The Final Echo</div>
      </div>
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5657" data-mp="2yg8nvffr9103">
      Series completion rate: 59.9% (Industry avg: 42%)
    </div>
  </div>;
export const MarketingToolsViz = () => <div className="h-64" data-id="element-5658" data-mp="2okxg5h2rku1u">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5659" data-mp="2ol6ziltb02yk">
      Marketing Campaign Performance
    </h4>
    <div className="grid grid-cols-2 gap-4 h-48" data-id="element-5660" data-mp="2aqecz3ezxmih">
      <div className="border rounded-lg p-3" data-id="element-5661" data-mp="2etb1tbv4qeuv">
        <h5 className="text-xs font-medium mb-2" data-id="element-5662" data-mp="2erzwv8py7126">Top Referral Sources</h5>
        <div className="space-y-2" data-id="element-5663" data-mp="20vmhq68vzbqv">
          <div className="flex justify-between items-center" data-id="element-5664" data-mp="20wnssapwjy8l">
            <span className="text-xs" data-id="element-5665" data-mp="25suyq3iat9qj">BookTok Campaign</span>
            <div className="w-24 h-3 bg-gray-100 rounded-full overflow-hidden" data-id="element-5666" data-mp="kwxxcvxvayi2">
              <div className="h-full bg-purple-500 rounded-full" style={{
              width: '85%'
            }} data-id="element-5667" data-mp="oz2pfq8o3n2l"></div>
            </div>
            <span className="text-xs font-medium" data-id="element-5668" data-mp="fycv6qz224qz">42%</span>
          </div>
          <div className="flex justify-between items-center" data-id="element-5669" data-mp="fymlygrxcfxq">
            <span className="text-xs" data-id="element-5670" data-mp="13p051hsj74g6">Email Newsletter</span>
            <div className="w-24 h-3 bg-gray-100 rounded-full overflow-hidden" data-id="element-5671" data-mp="18n1z0xrhwo6f">
              <div className="h-full bg-purple-500 rounded-full" style={{
              width: '60%'
            }} data-id="element-5672" data-mp="18p4lx8xcq16x"></div>
            </div>
            <span className="text-xs font-medium" data-id="element-5673" data-mp="yv5ogn8835lb">28%</span>
          </div>
          <div className="flex justify-between items-center" data-id="element-5674" data-mp="1mm1ebet4bqpx">
            <span className="text-xs" data-id="element-5675" data-mp="1re1ijjg815sb">Bookstagram</span>
            <div className="w-24 h-3 bg-gray-100 rounded-full overflow-hidden" data-id="element-5676" data-mp="1reuhvzcuot0f">
              <div className="h-full bg-purple-500 rounded-full" style={{
              width: '40%'
            }} data-id="element-5677" data-mp="3c2ndy0zeypit"></div>
            </div>
            <span className="text-xs font-medium" data-id="element-5678" data-mp="3kuyvexcjv2mn">18%</span>
          </div>
          <div className="flex justify-between items-center" data-id="element-5679" data-mp="3guewppcbvqye">
            <span className="text-xs" data-id="element-5680" data-mp="3gx151r71maho">Author Website</span>
            <div className="w-24 h-3 bg-gray-100 rounded-full overflow-hidden" data-id="element-5681" data-mp="2t5vqrggr3q9h">
              <div className="h-full bg-purple-500 rounded-full" style={{
              width: '25%'
            }} data-id="element-5682" data-mp="2o6riqt5kbykq"></div>
            </div>
            <span className="text-xs font-medium" data-id="element-5683" data-mp="2x6eilain8wbo">12%</span>
          </div>
        </div>
      </div>
      <div className="border rounded-lg p-3" data-id="element-5684" data-mp="heqpjq6r3ny5">
        <h5 className="text-xs font-medium mb-2" data-id="element-5685" data-mp="hhmmbb6v46l0">Email Signup Conversion</h5>
        <div className="flex flex-col h-32 justify-center items-center" data-id="element-5686" data-mp="cfnki5qrthq6">
          <div className="w-24 h-24 rounded-full border-8 border-purple-400 flex items-center justify-center" data-id="element-5687" data-mp="3697zjz85cqyr">
            <div className="text-center" data-id="element-5688" data-mp="3b6gn6fc2dn7e">
              <div className="text-2xl font-bold" data-id="element-5689" data-mp="3b9cjy0c6e5u9">24%</div>
              <div className="text-xs text-gray-500" data-id="element-5690" data-mp="3faekqllqqpyc">conversion</div>
            </div>
          </div>
          <div className="text-xs mt-2 text-green-600 flex items-center" data-id="element-5691" data-mp="3k6wnjfxige81">
            <ArrowUpIcon className="h-3 w-3 mr-1" data-id="element-5692" data-mp="2nigtb6jghgol" />
            5.2% from last month
          </div>
        </div>
      </div>
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5693" data-mp="2rk232j0p1euk">
      Data from last 90 days of marketing activity
    </div>
  </div>;
export const SalesConversionViz = () => <div className="h-64" data-id="element-5694" data-mp="319llxooep8pf">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5695" data-mp="31awppohuqggj">
      Sales Conversion Funnel
    </h4>
    <div className="h-48 relative" data-id="element-5696" data-mp="23testr3b2d4u">
      <div className="absolute inset-x-0 top-0 h-12 bg-indigo-100 rounded-t-lg flex items-center justify-between px-4" data-id="element-5697" data-mp="28t18e76lw5gt">
        <span className="text-sm" data-id="element-5698" data-mp="21a1nty7es7vv">Page Views</span>
        <span className="text-sm font-medium" data-id="element-5699" data-mp="218qjnxa1wy48">12,458</span>
      </div>
      <div className="absolute inset-x-5 top-10 h-10 bg-indigo-200 rounded-t-lg flex items-center justify-between px-4" data-id="element-5700" data-mp="1wbgp637t1w9j">
        <span className="text-sm" data-id="element-5701" data-mp="1r9iwyjhffr4g">Preview Readers</span>
        <span className="text-sm font-medium" data-id="element-5702" data-mp="1naa55k5y63bj">4,872 (39.1%)</span>
      </div>
      <div className="absolute inset-x-10 top-18 h-10 bg-indigo-300 rounded-t-lg flex items-center justify-between px-4" data-id="element-5703" data-mp="1ianrxaq4cn2q">
        <span className="text-sm" data-id="element-5704" data-mp="1djfkgk8cnbs7">Added to Cart</span>
        <span className="text-sm font-medium" data-id="element-5705" data-mp="1dhunknykbgr6">2,341 (18.8%)</span>
      </div>
      <div className="absolute inset-x-15 top-26 h-10 bg-indigo-400 rounded-t-lg flex items-center justify-between px-4" data-id="element-5706" data-mp="18ldxvpbpsubz">
        <span className="text-sm" data-id="element-5707" data-mp="13jonmbwbgkoy">Purchased</span>
        <span className="text-sm font-medium" data-id="element-5708" data-mp="zkfth5xd6ksv">1,872 (15.0%)</span>
      </div>
      <div className="absolute inset-x-20 top-34 h-10 bg-indigo-500 text-white rounded-t-lg flex items-center justify-between px-4" data-id="element-5709" data-mp="ulblgim6et44">
        <span className="text-sm" data-id="element-5710" data-mp="2uom6wbu1hk5b">Completed Reading</span>
        <span className="text-sm font-medium" data-id="element-5711" data-mp="2yowkoao2peuq">1,198 (9.6%)</span>
      </div>
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5712" data-mp="2yqqx10la3yn7">
      Price point analysis: $4.99 converts 15% better than $5.99
    </div>
  </div>;
export const ReaderPollsViz = () => <div className="h-64" data-id="element-5713" data-mp="2purnl9icj76r">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5714" data-mp="2azbsd161558s">
      Chapter 8 Poll Results: "Who do you think is the killer?"
    </h4>
    <div className="h-48 flex flex-col justify-between" data-id="element-5715" data-mp="2fzhnwsff7bw5">
      <div className="flex items-center" data-id="element-5716" data-mp="2fw29zsxhg8wb">
        <div className="w-32 text-sm" data-id="element-5717" data-mp="21zp29bir3lv1">Detective Morris</div>
        <div className="flex-1 h-8 bg-gray-100 rounded-full overflow-hidden" data-id="element-5718" data-mp="26xqkxvc9lj5z">
          <div className="h-full bg-indigo-500 rounded-full flex items-center px-3" style={{
          width: '48%'
        }} data-id="element-5719" data-mp="26zumi6moy633">
            <span className="text-xs text-white" data-id="element-5720" data-mp="5529iypgvpf4">48%</span>
          </div>
        </div>
        <div className="w-16 text-right text-sm" data-id="element-5721" data-mp="fbdd1e5lrcqp">412</div>
      </div>
      <div className="flex items-center" data-id="element-5722" data-mp="abh9th4qbpc7">
        <div className="w-32 text-sm" data-id="element-5723" data-mp="acscfdmfur1q">Sarah Johnson</div>
        <div className="flex-1 h-8 bg-gray-100 rounded-full overflow-hidden" data-id="element-5724" data-mp="o2dqc9ldsg2w">
          <div className="h-full bg-indigo-500 rounded-full flex items-center px-3" style={{
          width: '27%'
        }} data-id="element-5725" data-mp="o4gk94pnmtcw">
            <span className="text-xs text-white" data-id="element-5726" data-mp="xyytsqhr5j4m">27%</span>
          </div>
        </div>
        <div className="w-16 text-right text-sm" data-id="element-5727" data-mp="t1729xl0rz0y">231</div>
      </div>
      <div className="flex items-center" data-id="element-5728" data-mp="171rluvyrdyvi">
        <div className="w-32 text-sm" data-id="element-5729" data-mp="170oukmxixuf2">Mayor Williams</div>
        <div className="flex-1 h-8 bg-gray-100 rounded-full overflow-hidden" data-id="element-5730" data-mp="12zmte0k1r8ag">
          <div className="h-full bg-indigo-500 rounded-full flex items-center px-3" style={{
          width: '14%'
        }} data-id="element-5731" data-mp="38sl5pvfs529b">
            <span className="text-xs text-white" data-id="element-5732" data-mp="34tcfv1nv1oj1">14%</span>
          </div>
        </div>
        <div className="w-16 text-right text-sm" data-id="element-5733" data-mp="17sg7g2nzxf74">120</div>
      </div>
      <div className="flex items-center" data-id="element-5734" data-mp="1cqrhadeajppc">
        <div className="w-32 text-sm" data-id="element-5735" data-mp="1crsxsxe2t4eg">Dr. Reynolds</div>
        <div className="flex-1 h-8 bg-gray-100 rounded-full overflow-hidden" data-id="element-5736" data-mp="1hnrncob54sgg">
          <div className="h-full bg-indigo-500 rounded-full flex items-center px-3" style={{
          width: '11%'
        }} data-id="element-5737" data-mp="1mofh3hqr7ned">
            <span className="text-xs text-white" data-id="element-5738" data-mp="1vokmxngaudqf">11%</span>
          </div>
        </div>
        <div className="w-16 text-right text-sm" data-id="element-5739" data-mp="1vmhpwjgqbkc7">94</div>
      </div>
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5740" data-mp="20fsvyidpvx32">
      858 readers responded to this poll (72% response rate)
    </div>
  </div>;
export const TimeToReadViz = () => <div className="h-64" data-id="element-5741" data-mp="2aei2xg42rx4j">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5742" data-mp="2afbfixpptgul">
      Time Between Download and First Read
    </h4>
    <div className="h-48 flex items-end space-x-2" data-id="element-5743" data-mp="2eczdyaqm9rr8">
      <div className="flex flex-col items-center" data-id="element-5744" data-mp="2ryrk0pwhmcl">
        <div className="h-40 w-16 bg-indigo-500 rounded-t-lg" data-id="element-5745" data-mp="2pdppbplr6eu"></div>
        <div className="text-xs mt-1" data-id="element-5746" data-mp="3uty2fjeds6dv">Same day</div>
        <div className="text-xs font-medium" data-id="element-5747" data-mp="3pw69qn5wwg8m">42%</div>
      </div>
      <div className="flex flex-col items-center" data-id="element-5748" data-mp="3pyiqiwzxokk3">
        <div className="h-24 w-16 bg-indigo-400 rounded-t-lg" data-id="element-5749" data-mp="3ky4te9zvev0u"></div>
        <div className="text-xs mt-1" data-id="element-5750" data-mp="mfprrqbte09z">1-2 days</div>
        <div className="text-xs font-medium" data-id="element-5751" data-mp="meeemzwhbg67">25%</div>
      </div>
      <div className="flex flex-col items-center" data-id="element-5752" data-mp="hg338kqjcxlv">
        <div className="h-16 w-16 bg-indigo-300 rounded-t-lg" data-id="element-5753" data-mp="hheh5ddp3lqp"></div>
        <div className="text-xs mt-1" data-id="element-5754" data-mp="coutfnlana86">3-7 days</div>
        <div className="text-xs font-medium" data-id="element-5755" data-mp="cnjqfpzoa6i4">17%</div>
      </div>
      <div className="flex flex-col items-center" data-id="element-5756" data-mp="7qa3cgzra6xg">
        <div className="h-12 w-16 bg-indigo-200 rounded-t-lg" data-id="element-5757" data-mp="155xgh3eroo6n"></div>
        <div className="text-xs mt-1" data-id="element-5758" data-mp="158a7s76f0awd">8-14 days</div>
        <div className="text-xs font-medium" data-id="element-5759" data-mp="10f7d1vpwivel">12%</div>
      </div>
      <div className="flex flex-col items-center" data-id="element-5760" data-mp="8rw6s8bju7t6">
        <div className="h-8 w-16 bg-indigo-100 rounded-t-lg" data-id="element-5761" data-mp="8r4aeva4o61u"></div>
        <div className="text-xs mt-1" data-id="element-5762" data-mp="dj5u329mkz1w">15+ days</div>
        <div className="text-xs font-medium" data-id="element-5763" data-mp="djxgbmhc1kfi">8%</div>
      </div>
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5764" data-mp="3vxwu25mizdv3">
      Average time to first read: 4.2 days
    </div>
  </div>;
export const BounceRateViz = () => <div className="h-64" data-id="element-5765" data-mp="rinaoucrp606">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5766" data-mp="rjgky5axqdn2">
      Chapter Skim & Bounce Analysis
    </h4>
    <div className="h-48 relative" data-id="element-5767" data-mp="wgfdwkiv4ejo">
      <div className="absolute inset-0" data-id="element-5768" data-mp="wfdzq76jvbxq">
        <div className="h-full w-full bg-gray-100 rounded-lg overflow-hidden" data-id="element-5769" data-mp="ii8q5x7mnuxq">
          <div className="flex h-full" data-id="element-5770" data-mp="ngsda0xyjcro">
            {[...Array(15)].map((_, i) => <div key={i} className="flex-1 flex flex-col" data-id="element-5771" data-mp="nimy7f98b4vr" data-mpi={i}>
                <div className={`flex-1 ${i === 6 ? 'bg-red-400' : i === 5 ? 'bg-orange-300' : i === 7 ? 'bg-orange-300' : i >= 2 && i <= 4 ? 'bg-yellow-200' : i >= 8 && i <= 10 ? 'bg-yellow-200' : 'bg-green-200'} border-r border-white`} data-id="element-5772" data-mp="336d5s7b2n9m8"></div>
                <div className="text-xs text-center py-1" data-id="element-5773" data-mp="2vndnk4zcjo4g">{i + 1}</div>
              </div>)}
          </div>
          <div className="absolute top-1/4 left-[46.5%] transform -translate-x-1/2 bg-white px-2 py-1 rounded shadow-sm border text-xs" data-id="element-5774" data-mp="39noflbce78r7">
            <div className="font-medium text-red-600" data-id="element-5775" data-mp="34naekd97kz2o">28% bounce</div>
            <div data-id="element-5776" data-mp="2gzslmee7juy4">Chapter 7</div>
          </div>
        </div>
      </div>
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5777" data-mp="2c1r2xukp1xn6">
      Chapters with high bounce rates may benefit from revision
    </div>
  </div>;
export const ReturnSessionsViz = () => <div className="h-64" data-id="element-5778" data-mp="2lyc6ebh2f0ow">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5779" data-mp="2lx17aoykeh44">
      Reading Session Patterns
    </h4>
    <div className="grid grid-cols-2 gap-4 h-48" data-id="element-5780" data-mp="1y7gms1mrjbsq">
      <div className="border rounded-lg p-3" data-id="element-5781" data-mp="1ta7yrkexodjk">
        <h5 className="text-xs font-medium mb-2" data-id="element-5782" data-mp="1t9f25c9ov4f5">
          Number of Sessions to Complete
        </h5>
        <div className="h-32" data-id="element-5783" data-mp="pq1t18sljdjw">
          <div className="flex items-center mb-2" data-id="element-5784" data-mp="kqp8iup76ikh">
            <div className="w-24 text-xs" data-id="element-5785" data-mp="ks08ejfiv66b">1-3 sessions</div>
            <div className="flex-1 h-4 bg-gray-100 rounded-full overflow-hidden" data-id="element-5786" data-mp="zfbnuwetrabp">
              <div className="h-full bg-indigo-500 rounded-full" style={{
              width: '18%'
            }} data-id="element-5787" data-mp="uov8h6rg1emp"></div>
            </div>
            <div className="w-8 text-right text-xs" data-id="element-5788" data-mp="18i3191r9gg5z">18%</div>
          </div>
          <div className="flex items-center mb-2" data-id="element-5789" data-mp="13gx7d0lv6muv">
            <div className="w-24 text-xs" data-id="element-5790" data-mp="1ieza58l2n4b2">4-6 sessions</div>
            <div className="flex-1 h-4 bg-gray-100 rounded-full overflow-hidden" data-id="element-5791" data-mp="1icd1f5mg2ir9">
              <div className="h-full bg-indigo-500 rounded-full" style={{
              width: '42%'
            }} data-id="element-5792" data-mp="1dg4hlexay1dr"></div>
            </div>
            <div className="w-8 text-right text-xs" data-id="element-5793" data-mp="3f8an0n7my2ji">42%</div>
          </div>
          <div className="flex items-center mb-2" data-id="element-5794" data-mp="1upqbx1hjbv9h">
            <div className="w-24 text-xs" data-id="element-5795" data-mp="1ur1gh3it171n">7-10 sessions</div>
            <div className="flex-1 h-4 bg-gray-100 rounded-full overflow-hidden" data-id="element-5796" data-mp="1zn8lmu3dmeij">
              <div className="h-full bg-indigo-500 rounded-full" style={{
              width: '27%'
            }} data-id="element-5797" data-mp="1kxucnn3ppz3o"></div>
            </div>
            <div className="w-8 text-right text-xs" data-id="element-5798" data-mp="1bx4ienu3ogs2">27%</div>
          </div>
          <div className="flex items-center" data-id="element-5799" data-mp="1fzj3zfp5lun1">
            <div className="w-24 text-xs" data-id="element-5800" data-mp="1g1c7wn8du0rc">11+ sessions</div>
            <div className="flex-1 h-4 bg-gray-100 rounded-full overflow-hidden" data-id="element-5801" data-mp="120ja9tmsapk0">
              <div className="h-full bg-indigo-500 rounded-full" style={{
              width: '13%'
            }} data-id="element-5802" data-mp="16yumgb0jxc5e"></div>
            </div>
            <div className="w-8 text-right text-xs" data-id="element-5803" data-mp="31d3vgg0uaqcz">13%</div>
          </div>
        </div>
      </div>
      <div className="border rounded-lg p-3" data-id="element-5804" data-mp="2zvykpd84bg04">
        <h5 className="text-xs font-medium mb-2" data-id="element-5805" data-mp="2zwq3fngm9j8z">Average Session Length</h5>
        <div className="flex flex-col h-32 justify-center items-center" data-id="element-5806" data-mp="2uwlxush8y8xj">
          <div className="w-24 h-24 rounded-full border-8 border-indigo-400 flex items-center justify-center" data-id="element-5807" data-mp="2pxslj3dp4nyy">
            <div className="text-center" data-id="element-5808" data-mp="2kz7i6v35do6a">
              <div className="text-xl font-bold" data-id="element-5809" data-mp="2l08vl67mymr6">32</div>
              <div className="text-xs" data-id="element-5810" data-mp="3imzhpvpoh1h1">minutes</div>
            </div>
          </div>
          <div className="text-xs mt-2" data-id="element-5811" data-mp="3dnd1reigt74j">Median: 27 minutes</div>
        </div>
      </div>
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5812" data-mp="38wmx63hv58aw">
      18% of readers returned for a second complete reading
    </div>
  </div>;
export const FavoriteSectionsViz = () => <div className="h-64" data-id="element-5813" data-mp="33vh23z0qd8y7">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5814" data-mp="579xliqka0ky">
      Most Revisited Chapters
    </h4>
    <div className="h-48 flex items-end space-x-1" data-id="element-5815" data-mp="h38ziw1ug2p">
      {[8, 9, 10, 12, 3, 15, 7, 2, 5, 1, 4, 6, 11, 13, 14].map((chapter, index) => {
      const heights = [90, 85, 80, 75, 60, 55, 50, 45, 40, 35, 30, 25, 20, 15, 10];
      return <div key={index} className="flex-1 flex flex-col items-center" data-id="element-5816" data-mp="hq5ingz8z7gp" data-mpi={index}>
              <div className={`w-full ${index < 4 ? 'bg-indigo-500' : index < 8 ? 'bg-indigo-400' : 'bg-indigo-300'} rounded-t-sm`} style={{
          height: `${heights[index]}%`
        }} data-id="element-5817" data-mp="houhlox6sdta"></div>
              <div className="text-xs mt-1" data-id="element-5818" data-mp="voveyue8t340">{chapter}</div>
            </div>;
    })}
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5819" data-mp="10hyc1ci8auoy">
      Chapters 8-10 contain the most revisited content
    </div>
  </div>;
export const HighlightedQuotesViz = () => <div className="h-64" data-id="element-5820" data-mp="1afm7k4nns686">
    <h4 className="text-sm font-medium text-gray-700 mb-3" data-id="element-5821" data-mp="1age3xhp2y7zi">
      Most Highlighted Passages
    </h4>
    <div className="h-48 overflow-y-auto p-2 border rounded-lg" data-id="element-5822" data-mp="1feflfy6uxz8v">
      <div className="mb-3 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded" data-id="element-5823" data-mp="2c4rkf9e7p3ey">
        <div className="text-sm italic" data-id="element-5824" data-mp="276hk6kdmrcmh">
          "Sometimes the truth isn't what we want to see, but what we need to
          face."
        </div>
        <div className="text-xs text-gray-500 mt-1" data-id="element-5825" data-mp="2luku24usn8gk">
          Chapter 9 - Highlighted by 428 readers
        </div>
      </div>
      <div className="mb-3 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded" data-id="element-5826" data-mp="2gydl0373pgue">
        <div className="text-sm italic" data-id="element-5827" data-mp="1t6ovsvpkt8ho">
          "The darkness doesn't hide us; it merely reveals what we've been all
          along."
        </div>
        <div className="text-xs text-gray-500 mt-1" data-id="element-5828" data-mp="227de42m05v0d">
          Chapter 12 - Highlighted by 376 readers
        </div>
      </div>
      <div className="mb-3 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded" data-id="element-5829" data-mp="1y3ykg9555g4g">
        <div className="text-sm italic" data-id="element-5830" data-mp="3dl8tncgtk5s4">
          "She looked at him with eyes that had seen too much, and somehow,
          still hoped for more."
        </div>
        <div className="text-xs text-gray-500 mt-1" data-id="element-5831" data-mp="3h4hcimoyc2tr">
          Chapter 8 - Highlighted by 312 readers
        </div>
      </div>
      <div className="mb-3 p-3 bg-yellow-50 border-l-4 border-yellow-400 rounded" data-id="element-5832" data-mp="3m3kg02paa0zm">
        <div className="text-sm italic" data-id="element-5833" data-mp="376jp21ex2a27">
          "Fear isn't the absence of courage. It's the reason we need it."
        </div>
        <div className="text-xs text-gray-500 mt-1" data-id="element-5834" data-mp="3c5wcoodm3l5u">
          Chapter 15 - Highlighted by 287 readers
        </div>
      </div>
    </div>
    <div className="text-xs text-gray-500 mt-2 text-center" data-id="element-5835" data-mp="3rnpxwxrtoll">
      1,842 total highlights across all readers
    </div>
  </div>;
export const AdvancedMetricVisualization = ({
  metricId
}: {
  metricId: string;
}) => {
  switch (metricId) {
    case 'notify-readers':
      return <NotifyReadersViz data-id="element-5836" data-mp="3v25y5wqufdzv" />;
    case 'ab-testing':
      return <ABTestingViz data-id="element-5837" data-mp="mnnndn9ipkck" />;
    case 'genre-benchmarking':
      return <GenreBenchmarkingViz data-id="element-5838" data-mp="mm2stxn7e1ep" />;
    case 'series-performance':
      return <SeriesPerformanceViz data-id="element-5839" data-mp="rfnnpgti2f9o" />;
    case 'marketing-tools':
      return <MarketingToolsViz data-id="element-5840" data-mp="11be4kcfaji9n" />;
    case 'sales-conversion':
      return <SalesConversionViz data-id="element-5841" data-mp="118rw8akksyqd" />;
    case 'reader-polls':
      return <ReaderPollsViz data-id="element-5842" data-mp="wcufw49bbsdl" />;
    case 'time-to-read':
      return <TimeToReadViz data-id="element-5843" data-mp="sa67fxoignh5" />;
    case 'bounce-rate':
      return <BounceRateViz data-id="element-5844" data-mp="s8mqs5yy0aeu" />;
    case 'return-sessions':
      return <ReturnSessionsViz data-id="element-5845" data-mp="nbmkpv23f7nq" />;
    case 'favorite-sections':
      return <FavoriteSectionsViz data-id="element-5846" data-mp="nd7ehigl2mkj" />;
    case 'highlighted-quotes':
      return <HighlightedQuotesViz data-id="element-5847" data-mp="ics5f33c418d" />;
    default:
      return null;
  }
};